import jwt from "jwt-decode";
import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { logout } from "../helpers/functions/logout";

import ERP_Logo from "../img/erp_logo.png";
import { isMobile } from "../helpers/functions/isMobile";
import { useSidebar } from "./Dashboard/SidebarContext";
import { useLocation } from "react-router-dom";
import menuIcon from "../img/icons8-menu.svg";

function SuperAdminNavbar() {
  const token = localStorage.getItem("refreshToken");
  const user = jwt(token);
  const location = useLocation();

  const navHamburgerBtn = useRef(null);

  const handleNavHamburgerBtnClick = () => {
    document.getElementById("navbarSupportedContent").classList.toggle("show");
  };

  const { openSidebar } = useSidebar();

  return (
    <>
      <ToastContainer />

      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container-fluid">
          {/* <Link className="navbar-brand" to={`/`}>
            <img src={ERP_Logo} alt="logo" width="88" height="auto" />
          </Link> */}

          <div className="d-flex align-items-center">
            {/* Menu icon for mobile and tablet (hidden on lg and up) */}
            {isMobile &&
            location &&
            location?.pathname?.startsWith("/dashboard") ? (
              <button
                className="btn btn-link p-0 me-2 d-lg-none"
                onClick={openSidebar}
                style={{ border: "none", background: "transparent" }}
              >
                <img
                  src={menuIcon}
                  alt="menu"
                  style={{ width: "32px", height: "32px" }}
                />
              </button>
            ) : null}

            {/* Logo with responsive sizing */}
            <Link className="navbar-brand me-3" to="/">
              <img
                src={ERP_Logo}
                alt="logo"
                className="d-none d-md-block"
                style={{ width: "88px", height: "auto" }}
              />
              <img
                src={ERP_Logo}
                alt="logo"
                className="d-block d-md-none"
                style={{ width: "66px", height: "auto" }}
              />
            </Link>

            {/* Home link for desktop only */}
            <ul className="navbar-nav d-none d-lg-flex">
              <li className="nav-item">
                <Link className="nav-link active" aria-current="page" to="/">
                  Home
                </Link>
              </li>
            </ul>
          </div>
          <button
            className="navbar-toggler"
            type="button"
            // data-bs-toggle="collapse"
            // data-bs-target="#navbarSupportedContent"
            // aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            ref={navHamburgerBtn}
            onClick={handleNavHamburgerBtnClick}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav">
              <li className="nav-item">
                <Link
                  className="nav-link active"
                  aria-current="page"
                  to="/user/user-home"
                  onClick={() => {
                    window.innerWidth < 992 && handleNavHamburgerBtnClick();
                  }}
                >
                  User
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/bharartLoans/bharatLoans-home"
                  onClick={() => {
                    window.innerWidth < 992 && handleNavHamburgerBtnClick();
                  }}
                >
                  BharatLoan
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to={`/rto-list:` + user.phone + "&state=" + user.state}
                  onClick={() => {
                    window.innerWidth < 992 && handleNavHamburgerBtnClick();
                  }}
                >
                  RTO
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to={
                    `/superAdminDashboard:` +
                    user.phone +
                    "&state=" +
                    user.state
                  }
                  onClick={() => {
                    window.innerWidth < 992 && handleNavHamburgerBtnClick();
                  }}
                >
                  Dashboard
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to={
                    `/reports:` +
                    user.phone +
                    "&state=" +
                    user.state +
                    "&desig=" +
                    user.role
                  }
                  onClick={() => {
                    window.innerWidth < 992 && handleNavHamburgerBtnClick();
                  }}
                >
                  Reports
                </Link>
              </li>
              {/* <li className="nav-item">
                <Link className="nav-link" to="/operation/operation-home">
                  Operation
                </Link>
              </li> */}
            </ul>

            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to={`/select-designation`}
                  onClick={() => {
                    window.innerWidth < 992 && handleNavHamburgerBtnClick();
                  }}
                >
                  Roles
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to={`/Profile/${user.phone}`}
                  onClick={() => {
                    window.innerWidth < 992 && handleNavHamburgerBtnClick();
                  }}
                >
                  Profile
                </Link>
              </li>

              <li className="nav-item">
                <button className="nav-link border-0 bg-light" onClick={logout}>
                  Logout
                </button>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default SuperAdminNavbar;
